"use client";

import { envConfig } from "@/libs/env-config";
import Script from "next/script";

// Extend Window interface to include merchantInfo and kpUpdateDOM
declare global {
  interface Window {
    merchantInfo: {
      mid?: string;
      environment?: string;
      type?: string;
      [key: string]: unknown;
    };
    kpUpdateDOM?: () => void;
    handleLogout?: () => void;
  }
}

interface KwikPassScriptProps {
  onLoaded?: () => void;
}

export default function KwikPassScript({ onLoaded }: KwikPassScriptProps) {
  const onReady = () => {
    // Initialize the KwikPass DOM
    if (
      typeof window !== "undefined" &&
      typeof window.kpUpdateDOM !== "undefined"
    ) {
      window.kpUpdateDOM();
    }
    // Call the onLoaded callback once the script is ready
    if (onLoaded) onLoaded();
  };

  return (
    <>
      <Script id='kwikpass-init'>
        {`
            window.merchantInfo = {
                ...window.merchantInfo,
                mid: "${envConfig.gokwik.mid}",
                environment: "${envConfig.gokwik.environment}",
                type: "${envConfig.gokwik.type}",
            };
        `}
      </Script>
      <Script
        id='non-shopify-core-functions'
        src={`${envConfig.gokwik.scriptUrl}/kwikpass/non-shopify-core-functions.min.js`}
      />
      <Script
        id='merchant-v2'
        src={`${envConfig.gokwik.scriptUrl}/kwikpass/plugin/build/kp-merchant-v2.js`}
        strategy='afterInteractive'
        onReady={onReady}
      />
    </>
  );
}
